// Step indicator for CallOffWizard.tsx, split out to keep CallOffWizard.tsx
// under the 500-line cap. No behaviour change from the original inline
// definition — moved verbatim.
import type { WizardStep } from './callOffWizardHelpers';

export default function StepIndicator({ currentStep }: { currentStep: WizardStep }) {
  const steps = [
    { num: 1 as const, label: 'Supplier' },
    { num: 2 as const, label: 'Deliveries' },
    { num: 3 as const, label: 'Destination' },
  ];
  return (
    <div className="flex items-center justify-center gap-2 mb-6">
      {steps.map((step, idx) => (
        <div key={step.num} className="flex items-center gap-2">
          <div className={`flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-medium ${
            step.num < currentStep
              ? 'bg-green-100 text-green-700'
              : step.num === currentStep
                ? 'bg-primary text-primary-foreground'
                : 'bg-muted text-muted-foreground'
          }`}>
            {step.num < currentStep ? '✓' : step.num}
            <span>{step.label}</span>
          </div>
          {idx < steps.length - 1 && (
            <div className={`w-12 h-0.5 ${
              step.num < currentStep ? 'bg-green-300' : 'bg-muted'
            }`} />
          )}
        </div>
      ))}
    </div>
  );
}
